import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useCallback, useMemo } from "react";

const CheckboxInput = ({
  checked,
  defaultChecked,
  loading,
  label,
  sx,
  size = "small",
  grow,
  shrink,
  labelSx,
  labelFontSize = "13px",
  labelPlacement = "end",
  onChange,
}) => {
  const styles = useMemo(() => {
    return {
      flexGrow: grow ? 1 : 0,
      flexShrink: shrink ? 1 : 0,
      span: {
        fontSize: labelFontSize,
        ...labelSx,
      },
      ...sx,
    };
  }, [sx, labelSx, labelFontSize, shrink, grow]);

  const onCheckboxChange = useCallback(
    (e) => {
      const value = e.target.checked;
      if (onChange) {
        onChange(value);
      }
    },
    [onChange]
  );

  const checkboxContent = useMemo(() => {
    return loading ? (
      <CircularProgress size={13} sx={{ mr: 1 }} />
    ) : (
      <Checkbox
        defaultChecked={defaultChecked}
        checked={checked}
        size={size}
        onChange={onCheckboxChange}
      />
    );
  }, [loading, defaultChecked, checked, size, onCheckboxChange]);

  if (!label) {
    return checkboxContent;
  }
  return (
    <FormControlLabel
      label={label}
      labelPlacement={labelPlacement}
      sx={styles}
      control={checkboxContent}
    />
  );
};

export default CheckboxInput;
